// extracted by mini-css-extract-plugin
export default {"wrapper":"QJ","content":"RJ","firstSection":"SJ","text":"TJ","table":"UJ","tableText":"VJ","row":"WJ","column_2":"XJ","column_1":"YJ","column_3":"ZJ"};
    if(module.hot) {
      // 1738064241976
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  